import { Stack, Button, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import AppTheme from '@libs/mui/AppTheme';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ImperativeDialog } from '@shared/components/dialogs/imperative-dialog';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { useRef } from 'react';

type VisitDetailActionButtonsProps = {
  isVisitDeletable: boolean;
  onDelete: () => void;
};

const VisitDetailActionButtons = ({
  isVisitDeletable,
  onDelete,
}: VisitDetailActionButtonsProps) => {
  const { t } = useIntlTranslations();
  const deleteDialogRef = useRef<ImperativeFormDialogRefType | null>(null);

  return (
    <>
      <Stack
        spacing={2}
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        paddingY={2}
      >
        <Tooltip title={t('visitDetail.tooltipDelete')}>
          <Button
            onClick={() => deleteDialogRef.current?.open()}
            disabled={!isVisitDeletable}
            size="medium"
            sx={{
              backgroundColor: `${AppTheme.palette.common.white}`,
              color: `${AppTheme.palette.primary.main}`,
            }}
            startIcon={
              <DeleteOutlineIcon
                fontSize="small"
                color={!isVisitDeletable ? 'disabled' : 'primary'}
              />
            }
          >
            <FormattedMessage defaultMessage="Smazat" id="visitDetail.delete" />
          </Button>
        </Tooltip>
      </Stack>
      <ImperativeDialog
        ref={deleteDialogRef}
        title={t('visitDetail.tooltipDeleteConfirm')}
        dialogHelperText={t('visitDetail.tooltipDeleteHelperText')}
        onConfirm={onDelete}
      />
    </>
  );
};
export default VisitDetailActionButtons;
